export const Color = {
  jaune: "#FCAE3B",
  bleu: "#28348a",
  vert: "#1AA981",
  themeColor: "#726359",
  gris: "rgb(167, 167, 167)",
  success: "#1AA981",
  default: "#9203D7",
  white: "#fff",
  rouge: "#F45B5B",
};